import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PDFViewer, Loading } from "@components";
import { message } from "antd";
import * as API from "@api/admin";

export default function ViewReport() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [report, setReport] = useState(null);
  const [artist, setArtist] = useState(null);

  useEffect(() => {
    // Подгружаем данные трека
    async function fetchInitData() {
      const _res = {
        report: await API.Reports.getReport({ id }),
      };

      if (_res.report.error) {
        return message.error("Невозможно загрузить данные с сервера", 2);
      }

      _res.artist = await API.Artists.getArtist({
        id: _res.report.data.artist.id,
      });

      setIsLoading(false);
      setReport(_res.report.data);
      setArtist(_res.artist.data);
    }

    fetchInitData();
  }, []);

  if (isLoading || !report || !artist) {
    return <Loading />;
  }

  return <PDFViewer report={report} artist={artist} />;
}
